import { render, staticRenderFns } from "./cModalOxigeno.vue?vue&type=template&id=5afe52b1"
import script from "./cModalOxigeno.vue?vue&type=script&lang=js"
export * from "./cModalOxigeno.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports